module.exports = __webpack_public_path__ + "media/identify/icon_error-0f7f6fb5.svg";